<form *ngIf='form as form' novalidate autocomplete='off' [formGroup]='form' (ngSubmit)='submit()'>
  <div class='form-actions top'>
    <button type='button' class='btn btn-secondary' (click)='onPastDataFromLoginGov()'>
      <i class='fa fa-paste' aria-hidden='true'></i>
      Wczytaj dane z Profilu zaufanego
    </button>
    <button type='button' class='btn btn-secondary' (click)='onPastDataFromPortal()'>
      <i class='fa fa-paste' aria-hidden='true'></i>
      Wczytaj dane z Portalu e-usług
    </button>
  </div>
  <div class='row'>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"firstName" as controlName'>
        <label [for]='controlName'>
          Imię/Imiona *
        </label>
        <input
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'
          placeholder='Wpisz tu imię/imiona'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"lastName" as controlName'>
        <label [for]='controlName'>
          Nazwisko *
        </label>
        <input
          [id]='controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu nazwisko'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"phone" as controlName'>
        <label [for]='controlName'>
          Numer telefonu *
        </label>
        <input
          mask='0*'
          [id]='controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu numer telefonu'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"phone2" as controlName'>
        <label [for]='controlName'>
          Numer telefonu 2
        </label>
        <input
          mask='0*'
          [id]='controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu dodatkowy numer telefonu'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"email" as controlName'>
        <label [for]='controlName'>
          E-mail *
        </label>
        <input
          [id]='controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu e-mail'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"zipCode" as controlName'>
        <label [for]='controlName'>
          Kod pocztowy *
        </label>
        <input
          [id]='controlName'
          mask='00-000'
          [dropSpecialCharacters]='false'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu kod pocztowy'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"postOffice" as controlName'>
        <label [for]='controlName'>
          Poczta *
        </label>
        <input
          [id]='controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu pocztę'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"city" as controlName'>
        <label [for]='controlName'>
          Miejscowość *
        </label>
        <input
          [id]='controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu miejscowość'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"street" as controlName'>
        <label [for]='controlName'>
          Ulica
        </label>
        <input
          [id]='controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu nazwę ulicy'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-2'>
      <div class='form-group' *ngIf='"buildingNumber" as controlName'>
        <label [for]='controlName'>
          Nr domu *
        </label>
        <input
          [id]='controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu nr domu'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-2'>
      <div class='form-group' *ngIf='"apartmentNumber" as controlName'>
        <label [for]='controlName'>
          Nr mieszkania
        </label>
        <input
          [id]='controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu nr mieszkania'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
  </div>
  <br>
  <div class='form-actions'>
    @if (showCancel) {
      <button type='button' class='btn btn-secondary' (click)='cancel()'>
        <i class='fa fa-ban'></i>Anuluj
      </button>
    }
    <button type='submit' class='btn btn-secondary' *ngIf='edit'>
      <i class='fa fa-save'></i>Zaktualizuj dane
    </button>
    <button type='submit' class='btn btn-secondary' *ngIf='!edit'>
      <i class='fa fa-plus'></i>Dołącz do wniosku
    </button>
  </div>
</form>
